import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getFejlesztesiJavaslatok, createFejlesztesiJavaslatok, updateFejlesztesiJavaslatok, getSzakFelelosLeirasBySzakId, getSzak } from "../../apis/SzakokFinder";
//import "../../components/Ujszak.css";
import SideTile from "../SideTile";
//import "./FejlesztesiJavaslatok.css";
import "./SzakjelentesCreate.css";
import "./RadioButton.css";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import TopAlert from '../../components/TopAlert';
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import { FEJLESZTESIJAVASLATOK_TRANSLATIONS } from './FejlesztesiJavaslatokTranslations';
import { FEJLESZTESI_PRIORITASOK_OPTIONS } from './FejlesztesiJavaslatokOptions';


const FejlesztesiJavaslatokContent = ({ szakKod }) => {

    const [isSideTileVisible] = useState(true); // Added state for controlling SideTile visibility
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();
    const { language, loading } = useLanguage();

    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    const [fejlesztesiJavaslatok, setFejlesztesiJavaslatok] = useState({
        filling_status: 1,
    });
    const [fejlesztesiPrioritasok, setFejlesztesiPrioritasok] = useState([]); // Changed to array for checkboxes
    const [fejlesztesiPrioritasokMegjegyzes, setFejlesztesiPrioritasokMegjegyzes] = useState("");
    const [isNew, setIsNew] = useState(true);
    const [finalized, setFinalized] = useState(false); // Véglegesítés állapotának kezelése
    const [szakStatus, setSzakStatus] = useState(1); // Mely státuszban van a szakjelentés

    // Translations and options setup
    const t = loading ? {} : (FEJLESZTESIJAVASLATOK_TRANSLATIONS[language] || FEJLESZTESIJAVASLATOK_TRANSLATIONS.hu);
    const fejlesztesiPrioritasokOptions = loading ? [] : (FEJLESZTESI_PRIORITASOK_OPTIONS[language] || FEJLESZTESI_PRIORITASOK_OPTIONS.hu);

    // Helper function to build JSONB structure
    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    // Helper function to build JSONB structure for multi-select checkboxes
    const buildMultiSelectData = (selectedValues, options) => {
        if (!selectedValues || selectedValues.length === 0) return null;
        return {
            selected: selectedValues,
            options: options
        };
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Lekérdezzük a szakadatokat is a szakStatus beállításához
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const fejlesztesiJavaslatokResponse = await getFejlesztesiJavaslatok(szakId);
                if (fejlesztesiJavaslatokResponse.data.data.fejlesztesiJavaslatok.length > 0) {
                    const data = fejlesztesiJavaslatokResponse.data.data.fejlesztesiJavaslatok[0];
                    setFejlesztesiJavaslatok(data);
                    
                    // Set individual fields from response
                    if (data.fejlesztesi_prioritasok) setFejlesztesiPrioritasok(data.fejlesztesi_prioritasok.selected || []);
                    if (data.fejlesztesi_prioritasok_megjegyzes) setFejlesztesiPrioritasokMegjegyzes(data.fejlesztesi_prioritasok_megjegyzes);
                    
                    setFinalized(data.filling_status === 3);
                    setIsNew(false);
                } else {
                    const leirasResponse = await getSzakFelelosLeirasBySzakId(szakId);
                    if (leirasResponse.data.data.leiras) {
                        setFejlesztesiJavaslatok(prevState => ({
                            ...prevState,
                            fejlesztesi_javaslatok: leirasResponse.data.data.leiras
                        }));
                    }
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    // Ha 404 hiba van, új rekordot hozunk létre
                    try {
                        const newData = { filling_status: 1 };
                        await createFejlesztesiJavaslatok(szakId, newData);
                        setFejlesztesiJavaslatok(newData);
                        window.location.reload(); // Oldal újratöltése új rekord létrehozása után
                    } catch (createError) {
                        console.error("Error creating new fejlesztesi javaslatok record:", createError);
                    }
                } else {
                    console.log("Error fetching data:", error);
                }
            }
        };
        fetchData();
    }, [szakId]);

    useEffect(() => {
        const textareas = document.querySelectorAll("textarea");
        textareas.forEach((textarea) => {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        });
    }, [fejlesztesiJavaslatok]);

    const handleChange = (field, value) => {
        setFejlesztesiJavaslatok(prevState => ({
          ...prevState,
          [field]: value, // Save the updated HTML content
        }));
      };

    const handleFejlesztesiPrioritasokMegjegyzes = (value) => {
        setFejlesztesiPrioritasokMegjegyzes(value);
    };

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { 
                ...fejlesztesiJavaslatok, 
                filling_status: 2, // Always save with status 2
                fejlesztesi_prioritasok: buildMultiSelectData(fejlesztesiPrioritasok, FEJLESZTESI_PRIORITASOK_OPTIONS),
                fejlesztesi_prioritasok_megjegyzes: fejlesztesiPrioritasokMegjegyzes,
            };
            try {
                if (isNew) {
                    await createFejlesztesiJavaslatok(szakId, updatedData);
                } else {
                    await updateFejlesztesiJavaslatok(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [fejlesztesiJavaslatok, isNew, szakId, registerSaveHandler, unregisterSaveHandler, fejlesztesiPrioritasok, fejlesztesiPrioritasokMegjegyzes]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        try {
            const updatedData = { 
                ...fejlesztesiJavaslatok, 
                filling_status: status,
                fejlesztesi_prioritasok: buildMultiSelectData(fejlesztesiPrioritasok, fejlesztesiPrioritasokOptions),
                fejlesztesi_prioritasok_megjegyzes: fejlesztesiPrioritasokMegjegyzes,
            };
            if (isNew) {
                await createFejlesztesiJavaslatok(szakId, updatedData);
            } else {
                await updateFejlesztesiJavaslatok(szakId, updatedData);
            }
            // Mentés vagy véglegesítés után újratöltjük az oldalt
            window.location.reload();
        } catch (error) {
            console.error("Error submitting data:", error);
        }
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/mintatanterv-fejlesztesek`);
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/oktatas`);
    };

    const isFormValid = () => {
        return fejlesztesiPrioritasok.length > 0 && fejlesztesiPrioritasok.length <= 3;
    };

    const handleFinalize = (e) => {
        if (isFormValid()) {
            handleSubmit(e, 3); // Véglegesítés
        } else {
            // Show top alert instead of native alert
            setAlertMessage(t.alerts?.requiredFields || "Minden szöveges mezőt ki kell tölteni!");
            setShowAlert(true);
        }
    };

    const handleRevertFinalize = (e) => {
        handleSubmit(e, 2);
    };

    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <div className="uj-szak-container">
                <h1>{t.pageTitle}</h1>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    <div className="card">
                        <div className="form-group">
                            {fejlesztesiPrioritasokOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`fejlesztesi_prioritasok_${option.value}`}
                                        name="fejlesztesi_prioritasok"
                                        value={option.value}
                                        checked={fejlesztesiPrioritasok.includes(option.value)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                if (fejlesztesiPrioritasok.length < 3) {
                                                    setFejlesztesiPrioritasok([
                                                        ...fejlesztesiPrioritasok,
                                                        option.value
                                                    ]);
                                                }
                                            } else {
                                                setFejlesztesiPrioritasok(
                                                    fejlesztesiPrioritasok.filter(val => val !== option.value)
                                                );
                                            }
                                        }}
                                        disabled={finalized || (fejlesztesiPrioritasok.length >= 3 && !fejlesztesiPrioritasok.includes(option.value))}
                                    />
                                    <label htmlFor={`fejlesztesi_prioritasok_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                        <h4>{t.section1?.noteLabel}</h4>
                        <div className="form-group">
                            <RichTextEditor
                                name="fejlesztesi_prioritasok_megjegyzes"
                                value={fejlesztesiPrioritasokMegjegyzes}
                                onChange={handleFejlesztesiPrioritasokMegjegyzes}
                                disabled={finalized}
                            />
                        </div>
                    </div>
                    <div className="button-container">
                        <button className="szak-button" type="button" onClick={handleBack}>{t.buttons.previous}</button>
                        <div className="spacer"></div>
                        <button className="szak-button" type="button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={finalized || szakStatus >= 2}>{t.buttons.save}</button>
                        {finalized ? (
                            <button className="szak-button finalize-button" type="button" onClick={handleRevertFinalize} disabled={szakStatus >= 2}>{t.buttons.unfinalize}</button>
                        ) : (
                            <button className="szak-button finalize-button" type="button" onClick={handleFinalize} disabled={szakStatus >= 2}>{t.buttons.finalize}</button>
                        )}
                    </div>
                </form>
            </div>
            <SideTile id={szakId} texts={t.sidebar}
            isVisible={isSideTileVisible}
            />
        </div>
        </div>
    );
};

// Wrapper component to fetch szakKod and provide LanguageContext
const FejlesztesiJavaslatok = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                console.log('Fetching szakKod for szakId:', szakId);
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                const kod = response.data?.szak_kod || response.data?.data?.szak_kod;
                console.log('Extracted szak_kod:', kod);
                setSzakKod(kod);
            } catch (error) {
                console.error("Error fetching szak_kod:", error);
                setError(error.message);
                // Set a default to prevent infinite loading
                setSzakKod('default');
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        return <div>Loading page...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <FejlesztesiJavaslatokContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default FejlesztesiJavaslatok;
